export const getAppElement = () => document.getElementById('app') as HTMLElement
